<div class="table__container">
	<div class="table__header">
		<h2 class="table__title">
			{{ title }}
		</h2>
		<div class="header-right">
			<div class="d-flex btns-container" #btnsContainer>
				<!-- Generate Button -->
				<button
					class="btn--generate"
					nz-button
					nzType="primary"
					[disabled]="generateLoading || disableGenerate"
					(click)="handleBulkGenerate()"
				>
					{{ 'common_generate' | translate }}
					<ng-container *ngIf="generateLoading">
						<i class="ml-2" nz-icon [nzType]="'loading'"></i>
					</ng-container>
				</button>

				<!-- Send Button -->
				<button
					nz-button
					nzType="default"
					class="icon-btn"
					[title]="'common_send' | translate"
					[disabled]="disableSend || shouldDisableSend()"
					(click)="handleBulkSend()"
				>
					<i nz-icon nzType="mail" nzTheme="outline"></i>
				</button>

				<!-- Download Button -->
				<button
					nz-button
					nzType="default"
					class="icon-btn"
					[title]="'common_download' | translate"
					[disabled]="shouldDisableDownload()"
					(click)="handleBulkDownload()"
				>
					<i nz-icon nzType="download" nzTheme="outline"></i>
				</button>

				<!-- Delete Button -->
				<button
					nz-button
					nzType="default"
					class="icon-btn delete"
					[title]="'common_delete' | translate"
					[disabled]="disableDelete || shouldDisableDelete()"
					(click)="handleBulkDelete()"
				>
					<i nz-icon nzType="delete" nzTheme="outline"></i>
				</button>
			</div>

			<!-- Selected count label moved inside header -->
			<div class="selected-count-container">
				<div
					class="selected-count-label"
					[style.visibility]="hasSelected ? 'visible' : 'hidden'"
				>
					{{ selectedCount }} {{ 'common_selected' | translate }}
				</div>
			</div>
		</div>
	</div>
	<div class="table__wrapper">
		<table>
			<thead>
				<tr>
					<th width="40">
						<label
							nz-checkbox
							[ngModel]="isSelectAllChecked()"
							(ngModelChange)="toggleSelectAll()"
						>
						</label>
					</th>
					<th>{{ 'table_head-document-respondant' | translate }}</th>
					<th>{{ 'table_head-document-state' | translate }}</th>
					<th>{{ 'table_head-document-date' | translate }}</th>
					<th>{{ 'table_head-document-presence' | translate }}</th>
					<th>{{ 'table_head-document-actions' | translate }}</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngIf="loading">
					<tr>
						<td colspan="6" class="text-center">
							<i nz-icon nzType="loading"></i>
							{{ 'common_loading' | translate }}
						</td>
					</tr>
				</ng-container>
				<ng-container *ngIf="!loading">
					<ng-container
						*ngIf="displayItems.length > 0; else noAttestationsTpl"
					>
						<tr *ngFor="let item of displayItems; let i = index">
							<!-- Selection checkbox -->
							<td>
								<label
									nz-checkbox
									[ngModel]="isItemSelected(item)"
									(ngModelChange)="toggleItemSelection(item)"
								>
								</label>
							</td>

							<!-- Owner -->
							<td
								class="owner"
								[class.owner-clickable]="
									!item.isPartial && item.document
								"
								(click)="
									!item.isPartial &&
										item.document &&
										emitReadDocument.emit(item._id)
								"
							>
								{{ getOwnerName(item) }}
							</td>

							<!-- State -->
							<td
								class="state"
								*ngIf="!item.isPartial && item.document"
								[ngSwitch]="getDocumentStatus(item)"
							>
								<ng-container *ngSwitchCase="'created'">
									<span>{{
										'formation-intervention-state-admin-created'
											| translate
									}}</span>
								</ng-container>
								<ng-container *ngSwitchCase="'generated'">
									<span>{{
										'formation-intervention-state-admin-generated'
											| translate
									}}</span>
								</ng-container>
								<ng-container *ngSwitchCase="'sent'">
									<span>{{
										'formation-intervention-state-admin-sended'
											| translate
									}}</span>
								</ng-container>
								<ng-container *ngSwitchCase="'signed'">
									<span
										class="d-flex align-items-center justify-content-center"
									>
										<i
											nz-icon
											nzType="check-circle"
											class="mr-2"
											[style.color]="'black'"
										></i>
										<span>{{
											'formation-intervention-state-admin-signed'
												| translate
										}}</span>
									</span>
								</ng-container>
								<ng-container *ngSwitchDefault>
									<span>-</span>
								</ng-container>
							</td>
							<td
								class="state"
								*ngIf="item.isPartial || !item.document"
							>
								<span>-</span>
							</td>

							<!-- Date -->
							<td class="date">
								<span
									*ngIf="
										!item.isPartial &&
										item.document &&
										getCreatedDate(item)
									"
								>
									{{
										getCreatedDate(item)
											| date
												: 'dd MMMM yyyy'
												: ''
												: translateService.currentLang
									}}
								</span>
								<span
									*ngIf="
										item.isPartial ||
										!item.document ||
										!getCreatedDate(item)
									"
									>-</span
								>
							</td>

							<!-- Presence (merged column) -->
							<td class="presence">
								<ng-container
									*ngIf="
										item.total_hours !== null &&
										item.total_hours !== undefined
									"
								>
									<span>
										{{
											item.total_time_override ||
												item.total_presence ||
												0
										}}
										/ {{ item.total_hours }}
									</span>
								</ng-container>
								<span
									*ngIf="
										item.total_hours === null ||
										item.total_hours === undefined
									"
									>-</span
								>
							</td>

							<!-- Actions -->
							<td>
								<div class="actions">
									<!-- Generate button for specific respondant -->
									<button
										nz-button
										nzType="default"
										class="icon-btn"
										[title]="'common_generate' | translate"
										[disabled]="
											generateLoading || disableGenerate
										"
										(click)="openRespondantModal(item)"
									>
										<i
											nz-icon
											nzType="file-add"
											nzTheme="outline"
										></i>
									</button>

									<!-- Download button -->
									<button
										nz-button
										nzType="default"
										class="icon-btn"
										[title]="'common_download' | translate"
										[disabled]="!canDownload(item)"
										(click)="
											canDownload(item) &&
												emitDownloadDocument.emit({
													attestationId: item._id,
													filename:
														getDocumentLabel(item)
												})
										"
									>
										<i
											nz-icon
											nzType="download"
											nzTheme="outline"
										></i>
									</button>

									<!-- Send button -->
									<button
										nz-button
										nzType="default"
										class="icon-btn"
										[title]="'common_send' | translate"
										[disabled]="
											disableSend || !canDownload(item)
										"
										(click)="
											canDownload(item) &&
												emitSendDocument.emit(item._id)
										"
									>
										<i
											nz-icon
											nzType="mail"
											nzTheme="outline"
										></i>
									</button>

									<!-- Delete button -->
									<button
										nz-button
										nzType="default"
										class="icon-btn delete"
										[title]="'common_delete' | translate"
										[disabled]="
											disableDelete || !canDownload(item)
										"
										(click)="
											canDownload(item) &&
												emitDeleteDocument.emit(
													item._id
												)
										"
									>
										<i
											nz-icon
											nzType="delete"
											nzTheme="outline"
										></i>
									</button>
								</div>
							</td>
						</tr>
					</ng-container>
				</ng-container>
				<ng-template #noAttestationsTpl>
					<tr>
						<td colspan="6">
							{{ 'empty-attestations' | translate }}
						</td>
					</tr>
				</ng-template>
			</tbody>
		</table>
	</div>
</div>

<!-- Global Generate Modal -->
<nz-modal
	[(nzVisible)]="showGenerateModal"
	[nzTitle]="
		hasSelected
			? ('common_generate_selected' | translate)
			: ('generate_attestation' | translate)
	"
	(nzOnCancel)="
		showGenerateModal = false;
		globalTimeOverride = defaultTimeOverride;
		useOverride = false
	"
	(nzOnOk)="handleGenerateSubmit()"
	[nzOkLoading]="generateLoading"
>
	<ng-container>
		<div class="generate-popup">
			<div class="form-group">
				<label>{{ 'select_template' | translate }}</label>
				<nz-select
					class="w-100"
					[(ngModel)]="selectedTemplate"
					nzAllowClear="false"
					name="selectedTemplate"
				>
					<nz-option
						*ngFor="let template of templateOptions"
						[nzValue]="template"
						[nzLabel]="template | translate"
					></nz-option>
				</nz-select>
			</div>
			<div class="form-group mt-3">
				<label nz-checkbox [(ngModel)]="useOverride" name="useOverride">
					{{ 'override_presence_time' | translate }}
				</label>
			</div>
			<div class="form-group" *ngIf="useOverride">
				<label>{{ 'total_time_override' | translate }}</label>
				<input
					nz-input
					type="number"
					[(ngModel)]="globalTimeOverride"
					[placeholder]="defaultTimeOverride"
					name="globalTimeOverride"
				/>
			</div>
			<div class="form-group" *ngIf="!useOverride">
				<p class="text-muted">
					{{ 'use_respondant_presence_time' | translate }}
				</p>
			</div>
		</div>
	</ng-container>
</nz-modal>

<!-- Respondant Generate Modal -->
<nz-modal
	[(nzVisible)]="showRespondantModal"
	[nzTitle]="respondantModalTitle"
	(nzOnCancel)="
		showRespondantModal = false;
		respondantTimeOverride = respondantDefaultTimeOverride
	"
	(nzOnOk)="handleRespondantGenerateSubmit()"
	[nzOkLoading]="generateLoading"
>
	<ng-container>
		<div class="generate-popup">
			<div class="form-group">
				<label>{{ 'select_template' | translate }}</label>
				<nz-select
					class="w-100"
					[(ngModel)]="selectedTemplate"
					nzAllowClear="false"
				>
					<nz-option
						*ngFor="let template of templateOptions"
						[nzValue]="template"
						[nzLabel]="template | translate"
					></nz-option>
				</nz-select>
			</div>
			<div class="form-group">
				<label>{{ 'total_time_override' | translate }}</label>
				<input
					nz-input
					type="number"
					[(ngModel)]="respondantTimeOverride"
					[placeholder]="respondantDefaultTimeOverride"
				/>
			</div>
		</div>
	</ng-container>
</nz-modal>
